module.exports = __webpack_public_path__ + "img/plus.195b41ba.svg";